import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { DeletePopupComponent } from "../../../shared/components/delete-popup/delete-popup.component";
import { IncidentTrackerService } from "../../../shared/services/incident-tracker.service";
import { ToastrService } from "ngx-toastr";
import { AssessmentPreviewModalDialogComponent } from "../../../pages/incident-tracker/incident-tracker-templates/incident-tracker-templates.component";
import { IncidentTrackerAssessmentCreateModalDialogComponent } from "../../../pages/incident-tracker/incident-tracker-templates/incident-tracker-assessment-create-modal/incident-tracker-assessment-create-modal";
import textConfiguration from "../../../../assets/static-text-configuration.json";
import { AuditTemplateEditDialogComponent } from "../../components/audit-template-edit-dialog/audit-template-edit-dialog.component";
@Component({
  selector: "app-audits-library",
  templateUrl: "./audits-library.component.html",
  styleUrls: ["./audits-library.component.scss"],
})
export class AuditsLibraryComponent implements OnInit {
  @Input() dataLoaded: boolean;
  @Input() filteredTemplate: any[];
  @Input() unCategorizedTemplates: any[];
  @Input() showHeader: any = true;
  @Input() openFrom: any = "GRC-Library";
  @Input() activeTab: any = 0;
  @Output() templateDeleted = new EventEmitter<any>();
  templates: any = [];
  commonText: any = (textConfiguration as any).common;
  moduleName: any = (textConfiguration as any)?.modules?.audits;
  isCategoryView = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly incidentTrackerService: IncidentTrackerService,
    private readonly toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.showHeader === "false") {
      this.showHeader = false;
    }
  }

  toggleView() {
    this.isCategoryView = !this.isCategoryView;
  }

  getGMapRandomColor() {
    const colorNum = 360;
    const color = Math.floor(Math.random() * colorNum);
    return `hsla(${color}, 50%, 25%, 90%)`;
  }

  previewAssessment(template: any, tags: any) {
    const dialog = this.dialog.open(AssessmentPreviewModalDialogComponent, {
      width: "50vw",
      disableClose: true,
      autoFocus: false,

      data: {
        dataKey: template,
        tagsList: tags,
      },
    });
    dialog.afterClosed().subscribe((data) => {
      if (data) {
        this.proceed(template, tags);
      }
    });
  }

  proceed(template: any, tags: any) {
    this.dialog.open(IncidentTrackerAssessmentCreateModalDialogComponent, {
      width: "500px",
      disableClose: true,
      autoFocus: false,

      data: {
        template_id: template.id,
        template_name: template.title,
        openFrom: this.openFrom,
        activeTab: this.activeTab,
        moduleName: this.moduleName,
      },
    });
  }

  deleteTemplate(id: any, name: string) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      disableClose: true,
      data: name,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.incidentTrackerService.deletedAuditTemplate(id).subscribe(() => {
          this.toastrService.success("Template deleted successfully");
          this.unCategorizedTemplates = this.unCategorizedTemplates.filter(
            (item: any) => item.id !== id
          );
          this.templateDeleted.emit(this.unCategorizedTemplates.length);
        });
      }
    });
  }

  editTemplate(template: any) {
    const dialogRef = this.dialog.open(AuditTemplateEditDialogComponent, {
      width: "90vw",
      maxWidth: "90vw",
      disableClose: true,
      autoFocus: false,
      data: {
        template,
      },
    });
    dialogRef.afterClosed().subscribe((updatedTemplate: any) => {
      if (!updatedTemplate) {
        return;
      }
      this.toastrService.success("Template updated successfully");

      // Preserve the old card's color, or generate one if unavailable
      updatedTemplate.color = template.color || this.getGMapRandomColor();

      // Old template is now inactive; new one replaces it in the lists.
      this.unCategorizedTemplates = this.unCategorizedTemplates
        .filter((item: any) => item.id !== template.id)
        .concat(updatedTemplate);
      if (this.filteredTemplate?.length) {
        this.filteredTemplate = this.filteredTemplate.map((cat: any) => ({
          ...cat,
          templates: cat.templates
            .filter((item: any) => item.id !== template.id)
            .concat(
              cat.type === updatedTemplate.type?.display_name ||
                cat.type === updatedTemplate.type
                ? [updatedTemplate]
                : []
            ),
        }));
      }
      this.templateDeleted.emit(this.unCategorizedTemplates.length);
    });
  }
}
